import { useGetList } from 'react-admin';

/*
 * Helpers that let the admin pick values instead of typing them, so a typo
 * can't break a listing's link to the CRM.
 */

/** The official values of one CRM attribute (attributes.options), e.g. 'script' or 'size'. */
export const useCrmAttributeOptions = key => {
  const { data: attrs = [] } = useGetList('attributes', { pagination: { page: 1, perPage: 1000 }, sort: { field: 'id', order: 'ASC' } });
  const attr = attrs.find(a => a.key === key);
  return Array.isArray(attr?.options) ? attr.options.map(String) : [];
};

/** Select choices from values, keeping a saved value that's no longer in the CRM list. */
export const choicesOf = (values, current) =>
  [...new Set([...values, ...(current ? [String(current)] : [])])].map(v => ({ id: v, name: v }));

/** "Mezuzah Ari 12 cm" → "mezuzah-ari-12-cm" (the slug rule: a-z, 0-9, single hyphens). */
export const slugify = text => String(text ?? '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

/** On create: an empty slug is made from the English name (an existing slug is never rewritten). */
export const withSlugFromName = data => ({ ...data, slug: data.slug?.trim() || slugify(data.name_en) });
